import React, { useEffect, useState } from "react";
import { Skeleton, Image, Space, Button, notification, Divider } from "antd";
import hImg from "../../../assets/user-dashboard/h.png";
import convertImg from "../../../assets/user-dashboard/transfer.png";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { userWalletAction, userWalletSelectors } from "../../../store/wallet";
import { ShoppingCartOutlined } from "@ant-design/icons";
import userSelectors from "../../../store/user/selectors";
import { formatNumber } from "../../../constants/ConstantVar";
import BuyHavetoCoinModal from "../../Payment/BuyHavetoCoinModal";
import HAVETOApi from "../../../services/api/wallet/api";
import TransferHaveToModal from "../../Transfer/TransferHavetoCoinModal";
import SenderQRCode from "../../QRCode/SenderQRCode";
interface BalanceCardProps {
  data: number;
}
interface TransferProps {
  onModalClose: () => void;
}
const AdminTokenBalanceCard = () => {
  const totalSoldHTC = useAppSelector(userWalletSelectors.getTotalSoldHTC);
  const totalSoldUSD = useAppSelector(userWalletSelectors.getTotalSoldUSD);

  return (
    <>
      <div className="token-balance">
        <Image src={hImg} className="h-img" preview={false} />
        <Space direction="vertical" size={0}>
          <div className="text-16w">Token Sold</div>
          <div className="text-32w">
            {formatNumber(String(totalSoldHTC.toFixed(2)))}
            <sub className="sub-script-text">HaveTo</sub>
          </div>
        </Space>
      </div>
      <div className="equivalent_usd">
        <Image src={convertImg} className="h-img" preview={false} />
        <Space direction="vertical" size={0}>
          <div className="text-16w">Equivalent value</div>
          <div className="text-32w">
            {formatNumber(String(totalSoldUSD.toFixed(2)))}
            <sub className="sub-script-text">USD</sub>
          </div>
        </Space>
      </div>
    </>
  );
};

const UserTokenBalanceCard = () => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const { total_paid_usd } = useAppSelector(
    userWalletSelectors.fetchuserBalance
  );
  const walletBalance = useAppSelector(
    userWalletSelectors.getUserWalletBalance
  );
  const { USDT, ETH } = useAppSelector(userWalletSelectors.htcTokenConversion);
  return (
    <>
      <div className="token-balance">
        <Image src={hImg} className="h-img" preview={false} />
        <Space direction="vertical" size={0}>
          <div className="text-16w">Balance in USD</div>
          <div className="text-32w">
            {((walletBalance ?? 0) * (USDT ? USDT : 8)).toFixed(2)}
            <sub className="sub-script-text">USD</sub>
          </div>
        </Space>
      </div>
      <Button
        className="token-balance-btn"
        icon={<ShoppingCartOutlined />}
        onClick={() => setModalVisible(true)}
      >
        Buy HaveTo Token
      </Button>
      <BuyHavetoCoinModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
};

export const BalanceCard = () => {
  const dispatch = useAppDispatch();
  const walletBalance = useAppSelector(
    userWalletSelectors.getUserWalletBalance
  );
  const walletAddress = useAppSelector(
    userWalletSelectors.getUserWalletAddress
  );
  const walletLoader: boolean = useAppSelector(
    userWalletSelectors.getwalletLoader
  );

  useEffect(() => {
    let fetchBalanceInterval: NodeJS.Timeout;
    if (walletAddress) {
      dispatch(userWalletAction.userWalletBalance({ address: walletAddress }));
      // start polling every 30 sec
      fetchBalanceInterval = setInterval(() => {
        dispatch(
          userWalletAction.userWalletBalance({ address: walletAddress })
        );
      }, 30000);
    }
    return () => {
      if (fetchBalanceInterval) clearInterval(fetchBalanceInterval);
    };
  }, [walletAddress]);
  const isFirstLoad = walletBalance === null;
  return (
    <>
      {walletLoader && isFirstLoad ? (
        <>
          <div className="text-16w">Balance in Wallet</div>
          <Skeleton active paragraph={{ rows: 3 }} />
        </>
      ) : (
        <div className="token-balance" style={{ flexDirection: "column" }}>
          <Image src={hImg} className="h-img" preview={false} />
          <Space direction="vertical" size={0} style={{ alignItems: "center" }}>
            <div className="text-16w">Balance in Wallet</div>
            <div className="text-32w">
              {Number(walletBalance).toFixed(2)}
              <sub className="sub-script-text">HVT</sub>
            </div>
          </Space>
        </div>
      )}
    </>
  );
};
const TransferCard = () => {
  const dispatch = useAppDispatch();
  const walletAddress = useAppSelector(
    userWalletSelectors.getUserWalletAddress
  );
  const [modalVisible, setModalVisible] = React.useState(false);
  const [isQRVisible, setIsQRVisible] = useState(false);
  const closeQRModal = () => {
    setIsQRVisible(false);
  };
  const getBalance = () => {
    dispatch(userWalletAction.userWalletBalance({ address: walletAddress }));
  };
  return (
    <>
      <div className="token-balance" style={{ flexDirection: "column" }}>
        <Image src={hImg} className="h-img" preview={false} />
        <Space direction="vertical" size={0}>
          <div className="text-16w" style={{ textAlign: "center" }}>
            Transfer HVT
          </div>
        </Space>
        <div className="transfer-card-buttons">
          <Button
            style={{ marginTop: "5px", marginLeft: "0px", width: "50%" }}
            className="token-balance-btn"
            onClick={() => setModalVisible(true)}
          >
            Send
          </Button>
          <Button
            style={{ marginTop: "5px", marginLeft: "0px", width: "50%" }}
            className="token-balance-btn"
            onClick={() => setIsQRVisible(true)}
          >
            Receive
          </Button>
        </div>
      </div>

      <TransferHaveToModal
        data={walletAddress}
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
          getBalance();
        }}
      />
      <SenderQRCode
        visible={isQRVisible}
        address={walletAddress}
        onClose={() => {
          closeQRModal();
          getBalance();
        }}
      />
    </>
  );
};
const TokenBalanceCard = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelectors.getUserDetails);
  const loader: boolean = useAppSelector(userWalletSelectors.getLoader);

  useEffect(() => {
    dispatch(userWalletAction.userWalletAddress());
    if (user.is_staff && user.is_staff !== undefined) {
      dispatch(userWalletAction.totalSoldHTC());
      dispatch(userWalletAction.totalSoldUSD());
    } else if (!user.is_staff && user.is_staff !== undefined) {
      dispatch(userWalletAction.userWallet());
      dispatch(userWalletAction.totalSoldUSD());
    } else {
      return;
    }
  }, [dispatch, user.is_staff]);

  return (
    <>
      <div className="token-balance-card">
        {loader ? (
          <Skeleton active avatar paragraph={{ rows: 4 }} />
        ) : user.is_staff && user.is_staff !== undefined ? (
          <AdminTokenBalanceCard />
        ) : !user.is_staff && user.is_staff !== undefined ? (
          <UserTokenBalanceCard />
        ) : (
          <Skeleton active avatar paragraph={{ rows: 4 }} />
        )}
      </div>
      <Divider type="vertical" className="token-divider divider-visiblity" />
      <div className="token-balance-card">
        <BalanceCard />
      </div>
      <Divider type="vertical" className="token-divider divider-visiblity" />
      <div className="token-balance-card">
        <TransferCard />
      </div>
    </>
  );
};

export default TokenBalanceCard;
